import { render, staticRenderFns } from "./DocsPendentesCiencia.vue?vue&type=template&id=7764b754&"
import script from "./DocsPendentesCiencia.vue?vue&type=script&lang=js&"
export * from "./DocsPendentesCiencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports